import { useEffect } from 'react';
import { AsyncFunction, AsyncState } from './useAsync';

export function useAsyncEffect<T, TExecFunc extends AsyncFunction<T>, TError>(
  state: AsyncState<T, AsyncFunction<T>, TError>,
  deps: Parameters<TExecFunc>
): void {
  const { execute } = state;

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    execute(...deps);

    // Generally we should not disable exhaustive-deps, but here we need to merge the execute method with other
    // dependencies and we know that all dependencies are accounted.
  }, deps.concat(execute));
}
